import BaseServiceHttp from '../baseService'
class Obras extends BaseServiceHttp {
  constructor(id) {
    const resource = 'obras'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Obras(id)
